






















































import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'
import { Resource, ResourceType, GvdResourceNumber } from '@/store/modules/resource'
import { GvdPage } from '@/store/modules/gvd'
import { SlideDeckPage } from '@/store/modules/slideDeck'
import { EventBus } from '@/utils/event-bus'
import { saveAs } from 'file-saver'
import { lookup } from 'mime-types'
import ResourcePreviewModal from '@/views/products/resources/ResourcePreview.modal.vue'

@Component({
  components: {
    ResourcePreviewModal
  }
})
export default class GvdResourceList extends Vue {
  @Prop() resources!: Resource[]
  @Prop() resourceTypes!: ResourceType[]
  @Prop() showMarketLabels!: boolean
  @Prop() currentPageKey!: string

  selectedResource: Resource | null = null

  allowPreview: boolean = process.env.ALLOWPREVIEW === 'true'

  downloadMessage: string = this.allowPreview ? 'Preview:' : 'Download:'
  resourcesForType (resourceTypeKey: string) {
    if (!resourceTypeKey) {
      return this.resources.filter((r: any) => {
        return !r.resourceType
      })
        .sort((a: Resource, b: Resource) => { return a.name < b.name ? -1 : a.name > b.name ? 1 : 0 })
    }
    const _isAdmin = this.$route.path.includes('admin')
    const _publishedEntityKey: string = this.$store.getters.getActiveGvd.publishedEntity ? this.$store.getters.getActiveGvd.publishedEntity.key : ''
    const _resources: Resource[] = JSON.parse(JSON.stringify(this.resources))
      .filter((r: any) => {
        return r.resourceType ? r.resourceType.key === resourceTypeKey : false
      }).map((r: Resource) => {
        if (r.gvdResourceNumbers && r.gvdResourceNumbers.length) {
          const _gvdResourceNoForGvd = r.gvdResourceNumbers.find((rn: GvdResourceNumber) => {
            // console.log(rn.gvd.key)
            if (_isAdmin) {
              return rn.gvd.key === _publishedEntityKey
            }
            return rn.gvd.key === this.$store.getters.getActiveGvd.key
            // console.log(this.$store.getters.getActiveGvd.publishedEntity)
          })
          if (_gvdResourceNoForGvd) {
            r.name = `${_gvdResourceNoForGvd.number}. ${r.name}`
          }
        }
        return r
      }).sort((a: Resource, b: Resource) => {
        let _aResNum = -1
        let _bResNum = -1
        if (a.gvdResourceNumbers && a.gvdResourceNumbers.length) {
          if (_isAdmin && _publishedEntityKey.length) {
            _aResNum = a.gvdResourceNumbers.find((rn: GvdResourceNumber) => rn.gvd.key === _publishedEntityKey)?.number as number
            _bResNum = b.gvdResourceNumbers.find((rn: GvdResourceNumber) => rn.gvd.key === _publishedEntityKey)?.number as number
          } else if (!_isAdmin) {
            _aResNum = a.gvdResourceNumbers.find((rn: GvdResourceNumber) => rn.gvd.key === this.$store.getters.getActiveGvd.key)?.number as number
            _bResNum = b.gvdResourceNumbers.find((rn: GvdResourceNumber) => rn.gvd.key === this.$store.getters.getActiveGvd.key)?.number as number
          }
        }
        if (_aResNum > _bResNum && (_bResNum > 0)) {
          return 1
        } else if (_aResNum < _bResNum && (_aResNum > 0)) {
          return -1
        }

        // else sort by name
        return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0
      })
    return _resources
  }

  async downloadFile (resource: Resource) {
    if (this.allowPreview && (resource.fileExt === 'png' || resource.fileExt === 'pdf' || resource.fileExt === 'jpg')) {
      this.selectedResource = resource
      this.$bvModal.show('resource-preview-modal')
    } else {
      EventBus.$emit('show-loader')
      const resp = await axios.get(`resources/download/${resource.key}`, { withCredentials: true, responseType: 'blob' })
      if (!resp || resp.status !== 200) {
        EventBus.$emit('hide-loader')
        return
      }
      this.$store.dispatch('addEvent', { description: 'Resource download', data: { key: resource.key }, title: 'Resource download', eventType: 3, userAgent: navigator.userAgent, product: null, market: { key: this.$store.getters.getSelectedMarket }, trackingKey: resource.trackingKey })

      const _blob = new Blob([resp.data], { type: lookup(resource.filename as string) || undefined })
      saveAs(_blob, resource.filename)
      EventBus.$emit('hide-loader')
    }
  }

  shouldDisableInternalLink (page: GvdPage) {
    if (!page) {
      return false
    }
    if (this.$route.path.includes('admin')) {
      const _draftPage = this.$store.getters.getActiveGvdPages.find((p: GvdPage) => {
        return p.publishedKey === page.key
      })
      if (_draftPage) {
        return this.currentPageKey === _draftPage.key
      } else {
        return false
      }
    } else {
      return this.currentPageKey === page.key
    }
  }

  goToGvdPage (page: GvdPage) {
    if (this.$route.path.includes('admin')) {
      const _page = this.$store.getters.getActiveGvdPages.find((p: GvdPage) => {
        return p.publishedKey === page.key
      })
      if (_page) {
        this.$router.push({ query: { page: _page.key } })
      } else {
        console.warn(`Couldn't find page to jump to: ${_page.key}`)
      }
    } else {
      this.$router.push({ query: { page: page.key } })
    }
  }

  getGvdPageName (page: GvdPage) {
    let _pageNum = 1
    if (this.$route.path.includes('admin')) {
      _pageNum = (this.$store.getters.getActiveGvdPages.findIndex((p: GvdPage) => {
        return p.publishedKey === page.key
      }) + 1)
    } else {
      _pageNum = (this.$store.getters.getActiveGvdPages.findIndex((p: GvdPage) => {
        return p.key === page.key
      }) + 1)
    }

    // const _linkText = `page ${page.orderIdx + 1} of section ${page.gvdSection.orderIdx + 1}`
    const _linkText = `Page ${_pageNum}${page.title.length ? ': "' + page.title + '"' : ''}`
    return _linkText
  }

  goToSlideDeckPage (page: SlideDeckPage) {
    this.$router.push({ name: 'summary-slides', params: { productKey: page.slideDeckSection.slideDeck.product.key, slideDeckKey: page.slideDeckSection.slideDeck.key }, query: { page: page.key } })
  }

  getSlideDeckPageName (page: SlideDeckPage) {
    return `'${page.slideDeckSection.slideDeck.title}' summary slide deck`
  }
}
